import rankData from './ranks';

export const findUserRank = (score) => {
	const userRank = rankData.find(rank => score >= rank.minScore && score <= rank.maxScore);
	return userRank || rankData[0];
};

export default findUserRank;
